// gallery-main.js
import { initGalleryHome } from './gallery-home.js';
import { initGalleryListing, removeScrollListener } from './gallery-listing.js';
import { initGallerySingle } from './gallery-single.js';
import { getProcedureDetails } from './gallery-functions.js';

document.addEventListener('DOMContentLoaded', function() {

    const galleryMain = document.getElementById('gallery-main');

    if (!galleryMain) {
        return; // Exit the function if gallery elements are not present
    }

    handleURLParameters();

    // Delegate click event to dynamically generated elements
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('procedure-link')) {
            e.preventDefault();
            let procedureId = e.target.getAttribute('data-id');
            let procedureName = e.target.textContent;
            let isParent = e.target.classList.contains('parent-link');
            initGalleryListing(procedureId, isParent, procedureName);
        } else if (e.target.classList.contains('view-patient-btn')) {
            e.preventDefault();
            // Get patient and procedure IDs from the button's data attributes
            let patientId = e.target.getAttribute('data-id');
            let procedureId = e.target.getAttribute('data-procedure-id');
            
            if (patientId && procedureId) {
                getProcedureName(procedureId, function(procedureName) {
                    initGallerySingle(patientId, procedureId, procedureName);
                });
            } else {
                console.error('Missing patient or procedure ID');
            }
        } else if (e.target.closest('.back-to-top-btn')) {
            e.preventDefault();
            const galleryContainer = document.getElementById('gallery-procedures-container');
            const offset = 100;
            const elementPosition = galleryContainer.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });

    // Handle browser's back/forward buttons
    window.addEventListener('popstate', function(event) {
        handleURLParameters();
    });
});

function handleURLParameters() {
    removeScrollListener();
    const urlParams = new URLSearchParams(window.location.search);
    const procedureId = urlParams.get('procedureId');
    const patientId = urlParams.get('patientId');
    const page = parseInt(urlParams.get('page')) || 1;
    
    if (patientId && procedureId) {
        getProcedureName(procedureId, function(procedureName) {
            initGallerySingle(patientId, procedureId, procedureName);
        });
    } else if (procedureId) {
        getProcedureName(procedureId, function(procedureName) {
            initGalleryListing(procedureId, false, procedureName, page);
        });
    } else {
        initGalleryHome();
    }
}

function getProcedureName(procedureId, callback) {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxurl, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            const response = JSON.parse(xhr.responseText);
            if (response.success) {
                callback(response.data.name);
            } else {
                console.error('Failed to get procedure name:', response.data);
                callback('Unknown Procedure');
            }
        }
    };
    xhr.send('action=get_procedure_name&procedure_id=' + procedureId);
}

// Make initGalleryListing globally available
window.initGalleryListing = initGalleryListing;